import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  color: #0E2244;
  font-size: 1.5rem;
  font-weight: 700;
`;

export const SaveButton = styled.button`
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  background-color: #0E2244;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #13396f;
  }

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const InstructionText = styled.p`
  font-size: 1rem;
  color: #333;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

